import React, { useEffect, useState } from "react";

import {
  Box,
  Card,
  Typography,
  Divider,
  TableSortLabel,
  Avatar,
  Button,
  Grid,
  IconButton,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const styles = {
  editbox: {
    border: "1px solid #E6E8EF",
    color: "#4CAF50",
    width: "1.8125em",
    height: "1.8125em",
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    borderRadius: "0.375em",
    cursor: "pointer",
  },
  markbox: {
    border: "1px solid #E6E8EF",
    color: "#21D8A5",
    width: "7.5em",
    height: "1.8125em",
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    borderRadius: "0.375em",
    cursor: "pointer",
  },
  deletebox: {
    border: "1px solid #E6E8EF",
    color: "#FF5263",
    width: "1.8125em",
    height: "1.8125em",
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    borderRadius: "0.375em",
    cursor: "pointer",
  },
  eyebox: {
    border: "1px solid #E6E8EF",
    color: "#7C0E6F",
    width: "1.8125em",
    height: "1.8125em",
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    borderRadius: "0.375em",
    cursor: "pointer",
  },
  submitbox: {
    border: "1px solid #E6E8EF",
    color: "#21D8A5",
    width: "4em",
    height: "1.8125em",
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    borderRadius: "0.375em",
    cursor: "pointer",
  },
};
interface IProps {
  elements?: any;
  Send?: any;
  Edit?: any;
  delet?: any;
  True?: any;
  False?: any;
  View?: any;
  Add?: any;
  Mark?: any;
}
const ActionButton: React.FC<IProps> = ({
  elements,
  Send,
  Edit,
  delet,
  True,
  False,
  View,
  Add,
  Mark,
}) => {
  const { t, i18n } = useTranslation();
  const [show, setShow] = useState([
    "send",
    "edit",
    "delete",
    "true",
    "false",
    "view",
    "Mark",
    "print",
    "list",
    "arrow",
    "submit",
    "add",
  ]);

  const showThis = (element: any) => {
    if (show.includes(element)) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    if (elements) {
      setShow(elements);
    }
  }, [elements]);
  return (
    <Grid container spacing={1}>
      {showThis("send") && (
        <Grid item xs={3}>
          <Box style={styles.eyebox} onClick={Send}>
            <i className="las la-paper-plane"></i>
          </Box>
        </Grid>
      )}
      {showThis("edit") && (
        <Grid item xs={3}>
          <Box style={styles.editbox} onClick={Edit}>
            <i className="las la-pencil-alt"></i>
          </Box>
        </Grid>
      )}
      {showThis("delete") && (
        <Grid item xs={3}>
          <Box style={styles.deletebox} onClick={delet}>
            <i className="las la-trash-alt"></i>
          </Box>
        </Grid>
      )}
      {showThis("true") && (
        <Grid item xs={3}>
          <Box style={styles.editbox} onClick={True}>
            <i className="las la-check"></i>
          </Box>
        </Grid>
      )}
      {showThis("false") && (
        <Grid item xs={3}>
          <Box style={styles.deletebox} onClick={False}>
            <i className="las la-times"></i>
          </Box>
        </Grid>
      )}
      {showThis("view") && (
        <Grid item xs={3}>
          <Box style={styles.eyebox} onClick={View}>
            <i className="las la-eye"></i>
          </Box>
        </Grid>
      )}
      {showThis("add") && (
        <Grid item xs={3}>
          <Box style={styles.eyebox} onClick={Add}>
            <i className="las la-plus"></i>
          </Box>
        </Grid>
      )}
      {showThis("mark") && (
        <Grid item xs={4}>
          <Box style={styles.markbox} onClick={Mark}>
            <Typography
              style={{
                fontFamily: "Lato",
                fontSize: "0.78em",
                color: "#4CAF50",
              }}
            >
              {t("Mark as Complete")}
            </Typography>
          </Box>
        </Grid>
      )}
    </Grid>
  );
};
export default ActionButton;
